import Tag from '@/components/elements/Tag';
import { useNavigate } from 'react-router-dom';
import { slugify } from '@/utils/slugify';
import type { category } from '@/types/category';

interface ArticleTagsProps {
  tags: category[];
  tagLimit?: number;
  isPaid?: boolean;
}

function ArticleTags({ tags, tagLimit, isPaid }: ArticleTagsProps) {
  const navigate = useNavigate();

  return (
    <div>
      {tags
        ?.slice(0, tagLimit)
        .map((tag, index) => (
          <Tag
            variant='hollow'
            key={tag.id}
            label={tag.name}
            className={`${index > 0 ? 'hidden' : ''} md:inline-block`}
            onClick={() => navigate(`/category/${slugify(tag.name)}`)}
          />
        ))}
      {!isPaid && <Tag label='Free' variant='free-hollow' />}
    </div>
  );
}

export default ArticleTags;
